import * as React from 'react';
import { ShimmerContainer } from './ShimmerEffect.styles.js';
import { FadeInOut } from '../Animations/FadeInOut/FadeInOut.js';

const ShimmerEffect = ({ active =false , className , animationDurationInMs  })=>/*#__PURE__*/ React.createElement(FadeInOut, {
        active: active,
        animationDurationInMs: animationDurationInMs
    }, /*#__PURE__*/ React.createElement(ShimmerContainer, {
        className: className
    }));

export { ShimmerEffect };
